import { useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';

function useUpdateOutletContext(obj) {
  const context = useOutletContext();
  return useMemo(() => ({ ...context, ...obj }), [context, ...Object.values(obj)]); // eslint-disable-line react-hooks/exhaustive-deps
}

export default useUpdateOutletContext;
